import { Pipe, PipeTransform } from '@angular/core';
@Pipe({
  name: 'searchBy',
  pure: false
})
export class SearchByPipe implements PipeTransform {
  transform(items: any[], filter: string, searchByProperties: Array<string>): any {
    if (!items || !filter) {
        return items;
    }

    filter = filter.toLowerCase();

    return items.filter(item => {
      let containsText = false;
      _.forEach(searchByProperties, (property) => {
        const properties = property.split('.');
        let value = item;
        for(const prop of properties) {
          if(value&&value[prop]) {
            value= value[prop];
          }else{
            value = '';
          }
        }
        containsText = value.toString().toLowerCase().includes(filter);
        if(containsText) {
          return false;
        }
      });
      return containsText;
    });
  }
}
